module.exports = __webpack_public_path__ + "static/media/logo_bg.5fd4d420.png";